<template>
  <div class="bg">
    <portal to="app-bar-append">
      <v-btn v-if="mode !== 'sign-up'"
             elevation="0"
             color="deep-orange darken-4"
             @click="mode = 'sign-up'"
             rounded large dark>
        新規事業者登録
      </v-btn>
    </portal>

    <div class="container">
      <div class="logo"></div>
      <!-- ログイン -->
      <v-card tile class="form" v-if="mode === 'sign-in'">
        <v-form v-model="valid" autocomplete="on">
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-model="email"
                  label="Email"
                  type="email"
                  name="email"
                  placeholder=" "
                  :rules="[v => !!v || 'メールアドレスを入力してください']"
                  autofocus
                  @keydown.enter="handleSignIn()"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="password"
                  label="パスワード"
                  type="password"
                  name="password"
                  placeholder=" "
                  :rules="[v => !!v || 'パスワードを入力してください']"
                  @keydown.enter="handleSignIn()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions style="display: block;">
          <div>
            <v-btn
                color="primary"
                :disabled="!valid"
                :loading="loading"
                @click="handleSignIn"
                depressed>
              ログイン
            </v-btn>
          </div>
          <div class="pt-3">
            <v-btn
                :disabled="loading"
                @click="mode = 'password-reset'"
                link text small>
              パスワードを忘れた場合
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>

      <!-- 新規事業者登録 -->
      <v-card tile class="form" v-if="mode === 'sign-up'">
        <v-form v-model="valid" autocomplete="off">
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                  v-model="email"
                  label="Email"
                  type="email"
                  name="email"
                  placeholder=" "
                  :rules="[v => !!v || 'メールアドレスを入力してください']"
                  autofocus>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="ownerName"
                  label="事業者名"
                  placeholder=" "
                  :rules="[v => !!v || '事業者名を入力してください']">
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                  v-model="isComponentOwner"
                  label="コンポーネント事業者"
                  dense
                  hide-details>
                <template #append>
                  <el-tooltip :hide-after="10000" placement="top" popper-class="multi-line-tooltip-content">
                    <template #content>
                      コンポーネント事業者は、 CIOF コントローラを提供する事業者です。<br>
                      コンポーネント事業者は、外部辞書を定義する権限が付与されます。<br>
                      コンポーネント事業者として登録する場合は、本申込とは別に CIOF 事務局までご連絡ください。
                    </template>
                    <template #default>
                      <v-icon small color="blue" style="top: 4px;">mdi-help-circle</v-icon>
                    </template>
                  </el-tooltip>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                  v-model="isPlatformOwner"
                  label="プラットフォーム事業者"
                  dense
                  hide-details>
                <template #append>
                  <el-tooltip :hide-after="10000" placement="bottom" popper-class="multi-line-tooltip-content">
                    <template #content>
                      プラットフォーム事業者は、 CIOF による企業を越えたデータ連携を管理する事業者です。<br>
                      プラットフォーム事業者は、共通辞書を定義する権限が付与されます。<br>
                      プラットフォーム事業者として登録する場合は、本申込とは別に CIOF 事務局までご連絡ください。
                    </template>
                    <template #default>
                      <v-icon small color="blue" style="top: 4px;">mdi-help-circle</v-icon>
                    </template>
                  </el-tooltip>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions style="display: block; margin-top: 1rem;">
          <v-btn
              class="mr-4"
              :disabled="loading"
              @click="mode = 'sign-in'"
              link text small>
            ログインに戻る
          </v-btn>
          <v-btn
              color="primary"
              :disabled="!valid"
              :loading="loading"
              @click="handleSignUp"
              depressed>
            新規事業者登録
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- パスワードリセット -->
      <v-card tile class="form" v-else-if="mode === 'password-reset'">
        <v-form v-model="valid" autocomplete="on">
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-model="email"
                  label="Email"
                  type="email"
                  name="email"
                  placeholder=" "
                  :rules="[v => !!v || 'メールアドレスを入力してください']"
                  autofocus
                  @keydown.enter="handleRequestPasswordReset()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-btn
              class="mr-4"
              :disabled="loading"
              @click="mode = 'sign-in'"
              link text small>
            ログインに戻る
          </v-btn>
          <v-btn
              color="primary"
              :disabled="!valid"
              :loading="loading"
              @click="handleRequestPasswordReset"
              depressed>
            メールを送信
          </v-btn>
        </v-card-actions>
      </v-card>


      <!-- メンテナンス中 -->
      <v-card tile class="form" v-else-if="mode === 'maintenance'">
        <span class="maintenance-message">{{ globalAppMaintenance }}</span>
      </v-card>

      <!-- その他 -->
      <v-card tile class="form" v-else>
      </v-card>
    </div>

    <!-- reCAPTCHA BADGE 用 -->
    <div class="recaptcha-badge-container"></div>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import Swal from "sweetalert2";
import { load as loadReCaptcha } from "recaptcha-v3";

const reCaptchaSiteKey = '6LeNLgUfAAAAAFUCNxumrT7VVDfQlRZTrrI9hVNl';

export default {
  name: "SignIn",
  data() {
    return {
      email: '',
      password: '',
      valid: false,
      loading: false,
      modeIfOpen: 'sign-in',
      reCaptchaLoader: loadReCaptcha(reCaptchaSiteKey),

      // サインアップ用
      ownerName: '',
      staffName: '',
      isComponentOwner: false,
      isPlatformOwner: false,
    };
  },
  computed: {
    mode: {
      get() {
        if(this.globalAppStatus === 'closed') {
          return 'maintenance';
        } else if(this.globalAppStatus === 'open') {
          return this.modeIfOpen;
        }
        return 'unknown';
      },
      set(mode) {
        this.modeIfOpen = mode;
      }
    },
    globalAppStatus() {
      return this.$store.state.globalParams.status;
    },
    globalAppMaintenance() {
      return this.$store.state.globalParams.maintenance || 'ただいまメンテナンス中です。しばらくお待ちください。';
    },
  },
  methods: {
    ...mapActions({
      signIn: 'hcs/signIn',
      signUp: 'hcs/signUp',
      requestResetPassword: 'hcs/requestResetPassword',
    }),
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    async handleSignIn() {
      if(!this.valid) {
        return;
      }

      // reCAPTCHA
      const recaptcha = await this.reCaptchaLoader;
      const recaptchaToken = await recaptcha.execute('sign_in');

      try {
        this.loading = true;
        await this.signIn({email: this.email, password: this.password, recaptchaToken});
        let location = {name: 'Home'};
        if(this.$route.query.next) {
          location = {path: this.$route.query.next};
        }
        this.$router.replace(location).catch(() => {
          // 指定されたページを表示する権限が無かった場合
          this.$router.replace({name: 'Home'});
        });
      } catch (reason) {
        let msg = '。メールアドレスやパスワードに間違いがないか確認してみてください。';
        if(reason.request.status === 0) {
          msg = `\n${reason.message}`;
        }
        this.loading = false;
        this.showSnackbar({
          color: 'warn',
          message: `ログインに失敗しました${msg}`,
        });
        this.$el.querySelector('input').focus();
      }
    },
    async handleSignUp() {
      if(!this.valid) {
        return;
      }

      const recaptcha = await this.reCaptchaLoader;
      const recaptchaToken = await recaptcha.execute('sign_up');
      const email = this.email;
      const name = this.ownerName;
      const staffName = this.staffName;
      const componentOwner = this.isComponentOwner;
      const platformOwner = this.isPlatformOwner;

      try {
        this.loading = true;
        await this.signUp({email, name, staffName, componentOwner, platformOwner, recaptchaToken});
        this.modeIfOpen = 'sign-in';
        this.showSnackbar({
          message: `${email} へメールを送信しました。`
        });
      } catch (e) {
        await Swal.fire({
          title: '新規事業者登録失敗',
          html: `${email} へ登録用のメールを送信できませんでした。`,
          icon: 'warning',
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false
        });
      } finally {
        this.loading = false;
      }
    },
    async handleRequestPasswordReset() {
      if(!this.valid) {
        return;
      }

      const recaptcha = await this.reCaptchaLoader;
      const recaptchaToken = await recaptcha.execute('password_reset');
      const email = this.email;
      try {
        this.loading = true;
        await this.requestResetPassword({email, recaptchaToken});
        this.modeIfOpen = 'sign-in';
        this.showSnackbar({
          message: `${email} へメールを送信しました。`
        });
      } catch (e) {
        await Swal.fire({
          title: 'パスワードリセット失敗',
          html: `${email} へメールを送信できませんでした。`,
          icon: 'warning',
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false
        });
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    'ownerName': {
      immediate: true,
      handler(ownerName) {
        ownerName = ownerName?.trim();
        if(ownerName) {
          this.staffName = `${ownerName} Admin`;
        }
      }
    },
    '$route.query': {
      immediate: true,
      handler(query) {
        if('password_reset' in query) {
          const email = query.email;
          this.showSnackbar({
            message: `${email} のパスワードがリセットされました。新しいパスワードをメールで送信しました。`
          });
        }
        if(query["account_unlocked"] === "true") {
          this.showSnackbar({
            message: `アカウントロックが解除されました。パスワードを忘れた場合には、「パスワードを忘れた場合」ボタンより再発行してください。`
          });
        }

        if(query["account_unlocked"] === "false") {
          this.showSnackbar({
            color: "warn",
            message: "アカウントロックの解除に失敗しました。不明点は、掲示板に問い合わせください。"
          });
        }

        if('unauthorized' in query) {
          this.showSnackbar({
            color: "warn",
            message: "アクセスするには認証が必要です"
          });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$logo-width: 473px;
$logo-height: 323px;

.bg {
  background-color: #F5F6FA;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.container {
  display: flex;
  align-items: center;
  width: fit-content;
  position: relative;
  top: 50%;
  margin-top: -$logo-height * 0.5;
}

.logo {
  width: $logo-width;
  height: $logo-height;
  background-image: url('../../assets/logo-en.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.form {
  width: 360px;
  box-shadow: none !important;
  background-color: transparent !important;
}

.maintenance-message {
  display: block;
  white-space: pre-wrap;
}

.v-card__actions {
  padding: 10px 0 0 0;
  justify-content: center;
}
</style>

<style lang="css">
.grecaptcha-badge {
  display: none;
  z-index: -10;
}
</style>
